module.exports = __webpack_public_path__ + "static/ShopList-19669ba786144d9ca79feaf95ec67b3a.png";